export default __webpack_public_path__ + "static/media/AtlanticAveArtBlock.deeae707.jpg";